import {useEffect, useState} from "react";
import {IconButton, Snackbar, SnackbarContent} from "@mui/material";
import {CloseOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

const GlowingMessage = ({message, messageKey = message, onClose, autoHideDuration = 5000}) => {
    const {t} = useTranslation();
    const [open, setOpen] = useState(Boolean(message));
    useEffect(() => {setOpen(Boolean(message));}, [message, messageKey]);
    const dismiss = (_, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
        onClose?.();
    };
    if (!message) {
        return null;
    }

    return (
        <Snackbar key={messageKey} open={open} autoHideDuration={autoHideDuration} onClose={dismiss}
            disableWindowBlurListener anchorOrigin={{vertical: "bottom", horizontal: "center"}}>
            <SnackbarContent role="status" aria-live="polite" message={message}
                sx={{bgcolor: "#2f2d2d", overflowWrap: "anywhere"}}
                action={<IconButton size="small" color="inherit" aria-label={t("Close")} onClick={dismiss}>
                    <CloseOutlined fontSize="small"/>
                </IconButton>}/>
        </Snackbar>
    );
};

export default GlowingMessage;
